type scrollToElementProps = {
  element: string;
};

export const scrollToElement = ({
  element = "#rumbledirect-form",
}: scrollToElementProps): void => {
  if (!element) console.warn("No element provided to scroll to.");

  setTimeout(() => {
    const formElement = document.querySelector(element);

    if (!formElement)
      console.warn(
        `scrollToElement: element with selector '${element}' was not found.`,
      );
    formElement?.scrollIntoView({ behavior: "smooth" });
  }, 200);
};
